export interface UiModulePermission {
  id: number;
  permissions: number;
  moduleId: number;
  userId: string;
  referenceOrganizationId: string;
  relationType: string;
}

export enum UiModuleUserPermissions {
  Read = 1 << 0,   // 1
  Create = 1 << 1, // 2
  Update = 1 << 2, // 4
  Delete = 1 << 3, // 8
}
